
import { defineComponent } from "vue";
import MenuService from "@/api/Administration/MenuService";
import store from "@/store";
import { IMenuModel } from "@/interfaces/modules";

export default defineComponent({
  name: "MenuScreen",
  data() {
    return {
      form: {
        dialog: false,
        record: {} as IMenuModel,
      },
      table: {
        filters: {
          search: "",
        },
        currentPage: 1,
        loading: false,
        headers: [
          { key: "Name", label: "Nombre", sortable: true },
          { key: "Icon", label: "Ícono", sortable: true },
          { key: "Path", label: "Ruta", sortable: true },
          { key: "MenuPosition", label: "Posición", sortable: true },
          { key: "Enable", label: "Activo", sortable: true },
          { key: "CreatedByFormat", label: "Creación", sortable: true },
          { key: "ModifiedByFormat", label: "Última modificación", sortable: true },
          { key: "action", label: "Acciones", sortable: false },
        ],
        records: [] as IMenuModel[],
        rowsPerPage: 10,
      },
    };
  },
  computed: {
    filteredItems(): IMenuModel[] {
      const search = this.table.filters.search.toLowerCase();
      return this.table.filters.search
        ? this.table.records.filter(
            (item) =>
              item.Name?.toLowerCase().includes(search) ||
              item.Path?.toLowerCase().includes(search)
          )
        : this.table.records;
    },
    rows(): number {
      return this.table.records.length;
    },
  },
  mounted() {
    this.load();
  },
  methods: {
    async load() {
      this.table.loading = true;
      this.table.records = await MenuService.GetMenu();
      this.table.loading = false;
    },
    async edit(item: IMenuModel) {
      this.form.record = await MenuService.GetMenuById(item);
      this.form.dialog = true;
    },
    openModal() {
      this.form.record = { Enable: true } as IMenuModel;
      this.form.dialog = true;
    },
    async handleSubmit() {
      this.form.dialog = false;
      await MenuService.PostMenu(this.form.record);
      store.dispatch("core/popupDialog", {
        text: "Registro guardado con éxito.",
        type: "success",
        showCancelButton: false,
      });
      this.load();
    },
  },
});
